import api from './utils/api';

class PaymentService {
  async checkout(data) {
    const result = await api.post('/payment/checkout', data);
    return result.data;
  }

  async upgradeCheckout(data) {
    const result = await api.post('/payment/upgrade/checkout', data);
    return result.data;
  }

  async getById(id) {
    const result = await api.get(`/payment/${id}`);
    return result.data;
  }

  async list(params) {
    const result = await api.get('/payment', { params });
    return result.data;
  }

  async cancel(id) {
    const result = await api.delete(`/payment/${id}`);
    return result.data;
  }
}

export default new PaymentService();
